import { v4 as uuidv4 } from "uuid";
export class USZipCodeModel {
    constructor() {
        this.id = uuidv4();
        this.city = " ";
        this.state = " ";
        this.country = " ";
    }
}
export default class USZipCode extends USZipCodeModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
